import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  /** Active products from checkProductStatusV5 API (res?.data?.products) */
  activeProducts: [],
};

const productSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    setActiveProducts(state, action) {
      state.activeProducts = Array.isArray(action.payload) ? action.payload : [];
    },
    clearActiveProducts(state) {
      state.activeProducts = [];
    },
  },
});

export const { setActiveProducts, clearActiveProducts } = productSlice.actions;
export default productSlice.reducer;
